<template>
  <div v-if="loading">
    <van-form v-if="id != 1">
      <van-field label="平台">
        <template #input>
          <span>{{ form.platform.platform_name }}</span>
        </template>
      </van-field>
      <van-field label="影院">
        <template #input>
          <span>{{ form.cinema.name }}</span>
        </template>
      </van-field>
      <van-field label="成本">
        <template #input>
          <span>{{ form.cinema.remark || "" }}</span>
        </template>
      </van-field>
      <van-field label="匹配影厅类型">
        <template #input>
          <span v-if="form.hall_type === -1">全部影厅</span>
          <span v-else-if="form.hall_type === 1">特殊影厅</span>
          <span v-else-if="form.hall_type === 0">普通影厅</span>
          <span v-else>未知影厅</span>
        </template>
      </van-field>
      <van-field label="匹配价范围">
        <template #input>
          <span>{{ form.min_price }}元 ~ {{ form.max_price }}元</span>
        </template>
      </van-field>
      <van-field label="报价" v-model="form.price" placeholder="输入报价" />
      <span style="color: red;padding-left: 15px;">{{ form.platform.remark || "" }}</span>
      <div style="margin: 16px">
        <van-button round block type="info" @click="updateOrder">保存</van-button>
      </div>
    </van-form>
    <van-collapse v-model="activeNames">
      <van-collapse-item v-for="(item, index) in form.orders" :key="index" :name="index">
        <template slot="title">
          <div>{{ '软件报价：' + item.bid_price + '，成交价：' + item.final_price }}
            <van-icon v-if="item.has_bid" name="https://www.pic.jiaowushu.com/other/right.png" />
            <van-icon v-else name="https://www.pic.jiaowushu.com/other/wrong.png" />{{ '，中标价：' + item.p_bid_price +
              '，最高报价：' + item.supplier_max_price }}
          </div>
        </template>
        <div>影院：{{ item.cinema_name }}</div>
        <div>电影：{{ item.film_name }}</div>
        <div>影厅：{{ item.hall_name }}</div>
        <div>单号：{{ item.order_number }}</div>
        <div>市场价：{{ item.tpp_price }}</div>
        <div>创建时间：{{ item.created_at }}</div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeNames: [0],
      order_no: '',
      loading: false,
      form: {
        orders: []
      }
    }
  },
  created () {
    this.id = this.$route.query.id
    this.cinema_platform_id = this.$route.query.cinema_platform_id
    this.cinema_id = this.$route.query.cinema_id
    if (this.id) {
      this.getMyOrderDetail()
    }
  },
  methods: {
    async updateOrder () {
      const { data: res } = await this.$http.post('movie/order/rules/update', this.form)
      if (res.code === 200) {
        this.$toast(res.msg)
      }
    },
    async getMyOrderDetail () {
      this.loading = false
      const { data: res } = await this.$http.get('movie/order/rules/detail?id=' + this.id + "&cinema_id=" + this.cinema_id + "&cinema_platform_id=" + this.cinema_platform_id)
      if (res.code === 200) {
        this.loading = true
        this.form = res.data
      }
    }
  },
  components: {}
}
</script>

<style scoped>
.header {
  background: #4a4a56;
  padding: 2rem;
  text-align: center;
}

.header div {
  text-align: center;
  color: #c2c4d4;
  font-size: 16px;
}

.van-image {
  width: 80%;
}

.text {
  color: #8d9da7;
  padding: 1rem;
}

.text_1 {
  color: #f10e0e;
  padding: 1rem;
}

.mod {
  margin: 1rem;
  text-align: center;
}
</style>
